module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vresp11-7178cf54e736aff7bbcfcd85ee697571.jpg";